import React from 'react';
import { Mail, Phone, MapPin, Instagram, Youtube, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Footer.css';

// Behance icon component
const BehanceIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M22 7h-7v-2h7v2zm1.726 10c-.442 1.297-2.029 3-5.101 3-3.074 0-5.564-1.729-5.564-5.675 0-3.91 2.325-5.92 5.466-5.92 3.082 0 4.964 1.782 5.375 4.426.078.506.109 1.188.095 2.14h-8.027c.13 3.211 3.483 3.312 4.588 2.029h3.168zm-7.686-4h4.965c-.105-1.547-1.136-2.219-2.477-2.219-1.466 0-2.277.768-2.488 2.219zm-9.574 6.988h-6.466v-14.967h6.953c5.476.081 5.58 5.444 2.72 6.906 3.461 1.26 3.577 8.061-3.207 8.061zm-3.466-8.988h3.584c2.508 0 2.906-3-.312-3h-3.272v3zm3.391 3h-3.391v3.016h3.341c3.055 0 2.868-3.016.05-3.016z"/>
  </svg>
);

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { name: 'About Us', href: '/about' },
      { name: 'Our Services', href: '/services' },
      { name: 'Portfolio', href: '/portfolio' },
      { name: 'Careers', href: '/careers' },
      { name: 'Contact', href: '/contact' }
    ],
    services: [
      { name: 'Wedding Films', href: '/services' },
      { name: 'Corporate Videos', href: '/services' },
      { name: 'Social Media', href: '/services' },
      { name: 'Documentaries', href: '/services' }
    ],
    contact: [
      { icon: Phone, text: '+91 93135 53726', href: 'tel:+919313553726' },
      { icon: Mail, text: 'Smilegnr@outlook.com', href: 'mailto:Smilegnr@outlook.com' },
      { icon: MapPin, text: 'Gandhinagar, Gujarat', href: '#' }
    ]
  };

  const socialLinks = [
    { icon: Instagram, href: 'https://www.instagram.com/rse.editing', label: 'Instagram' },
    { icon: Youtube, href: 'https://www.youtube.com/@rse-edit', label: 'Youtube' },
    { icon: Linkedin, href: 'https://www.linkedin.com/company', label: 'LinkedIn' },
    { icon: BehanceIcon, href: 'https://www.behance.net/keyurrao1', label: 'Behance' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/footer-logo.png" alt="RSE Post Production House" className="footer-logo-image" />
            </Link>
            <p className="footer-tagline">
              Unleashing creativity, one frame at a time
            </p>
            <div className="footer-social">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    className="footer-social-link"
                    aria-label={social.label}
                  >
                    <Icon size={20} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Company Links */}
          <div className="footer-column">
            <h4 className="footer-column-title">Company</h4>
            <ul className="footer-links">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <Link to={link.href} className="footer-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div className="footer-column">
            <h4 className="footer-column-title">Services</h4>
            <ul className="footer-links">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <Link to={link.href} className="footer-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-column">
            <h4 className="footer-column-title">Contact</h4>
            <ul className="footer-contact">
              {footerLinks.contact.map((item, index) => {
                const Icon = item.icon;
                return (
                  <li key={index}>
                    <a href={item.href} className="footer-contact-item">
                      <Icon size={16} />
                      <span>{item.text}</span>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} RSE Post Production House. All rights reserved.
          </p>
          <p className="footer-tagline">
            Remote video editing services • Serving clients worldwide
          </p>
          <div className="footer-bottom-links">
            <a href="#" className="footer-bottom-link">Privacy Policy</a>
            <span className="footer-divider">•</span>
            <a href="#" className="footer-bottom-link">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
